import Spinner, { Appearance } from '@atlaskit/spinner';
import React from 'react';
import './loading-indicator.scss';

export type Size = React.ComponentProps<typeof Spinner>['size'];

export const DEFAULT_LOADING_INDICATOR_ID = 'loading-indicator';

interface Props {
  size?: Size;
  container?: keyof React.ReactHTML;
  appearance?: Appearance;
}

export const LoadingIndicator = ({ container = 'div', size = 'large', appearance = 'inherit' }: Props) => {
  const containerProps = {
    'data-testid': 'loading-indicator',
    className: 'loading-indicator-container',
  };

  // eslint-disable-next-line react/no-children-prop
  return React.createElement(container, {
    ...containerProps,
    children: <Spinner size={size} appearance={appearance} />,
  });
};
